import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const InfoIcon = ({ onClick }) => (
  <svg onClick={ onClick } className="info-icon" viewBox="0 0 98.525 98.525">
    <g>
      <path d="M49.737.437A49.263,49.263,0,1,0,99,49.7,49.318,49.318,0,0,0,49.737.437Zm0,93.282A44.02,44.02,0,1,1,93.757,49.7,44.069,44.069,0,0,1,49.737,93.719Z" transform="translate(-0.475 -0.437)"/>
      <rect x="46.641" y="42.21" width="5.243" height="31.864"/>
      <circle cx="49.263" cy="28.819" r="4.387"/>
    </g>
  </svg>
);

InfoIcon.propTypes = {
  onClick: PropTypes.func
};

export default InfoIcon;
